import { useBooleanFlags } from '@/core/flags/flags.hooks';
import { P } from '@/core/tamagoshiTailwind/components/Typography/Typography';
import { twMerge } from '@/core/tamagoshiTailwind/util/twMerge';
import { BillieIcon } from '@/core/tamagoshiv2/icons/payment/BillieIcon';
import {
  differedPayment,
  payLater,
} from '@/customerFinanceOperations/components/BillieBannerV2/translations';
import { FeatureFlags } from '@/customerFinanceOperations/constants/FeatureFlags';

interface Props {
  className?: string;
}

export const BillieBannerV2 = ({ className }: Props) => {
  const [buyNowPayLaterV2] = useBooleanFlags([
    FeatureFlags.BUY_NOW_PAY_LATER_V2,
  ]);

  if (!buyNowPayLaterV2) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'w-full rounded-card bg-foundation-primary p-s text-foundation-primary',
        className,
      )}
    >
      <P scale="body2" weight="semibold">
        {payLater}
      </P>
      <div className="flex items-center gap-s">
        <P scale="body2">{differedPayment}</P>
        <BillieIcon className="size-[32px]" />
      </div>
    </div>
  );
};

BillieBannerV2.displayName = 'BillieBannerV2';
